import { createSlice } from "@reduxjs/toolkit";

export const loadingSlice = createSlice({
  name: "loading",
  initialState: {
    globalLoading: false,
    sectionLoading: false,
    actionLoading: false,
    screenSizeType: "2xl",
  },
  reducers: {
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload;
    },
    setSectionLoading: (state, action) => {
      state.sectionLoading = action.payload;
    },
    setActionLoading: (state, action) => {
      state.actionLoading = action.payload;
    },
    setScreenSizeType: (state, action) => {
      state.screenSizeType = action.payload;
    },
    clearLoadingData: (state, action) => {
      state.globalLoading = false;
      state.sectionLoading = false;
      state.actionLoading = false;
    },
  },
});

export const { setGlobalLoading, setSectionLoading, setActionLoading, setScreenSizeType, clearLoadingData } = loadingSlice.actions;

export const loadingState = (state) => state.loading;

export default loadingSlice.reducer;
